import { Button, Stack, Text } from '@chakra-ui/react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'

import type { PostEventDetails } from '@/components/Community/Post/types'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function DeletePostEventModal({
  postEvent,
  open,
  onDelete,
  onClose,
}: {
  postEvent: PostEventDetails
  open: boolean
  onDelete: (clientId: string) => void
  onClose: () => void
}): JSX.Element {
  const [handleDeleteComment, isDeleting] = useAPIWrapper(
    async () => {
      onDelete(postEvent.clientId)

      await RPC.deletePostComment({
        postEventId: postEvent.id,
      })

      onClose()
    },
    [onDelete, postEvent.clientId, postEvent.id, onClose],
    'Delete Post Comment'
  )

  return (
    <ModalV3
      size="lg"
      open={open}
      onClose={onClose}
      title="Delete Comment"
      body={() => <Text>Are you sure you&apos;d like to delete this comment?</Text>}
      rightFooterContent={() => (
        <Stack direction="row" spacing="8px">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleDeleteComment} isLoading={isDeleting} variant="danger">
            Delete
          </Button>
        </Stack>
      )}
    />
  )
}
